export const paymentFrequencyList = [
    { name: "Yearly", code: "yearly" },
    { name: "Monthly", code: "monthly" },
    { name: "Half Yearly", code: "halfyearly" },
    { name: "Quarterly", code: "quarterly" },
];

export const frequencyListInShort = [
    { name: "Yearly", code: "Y" },
    { name: "Monthly", code: "M" },
    { name: "Half Yearly", code: "H" },
    { name: "Quarterly", code: "Q" },
];